import { useQuery } from 'react-query';

import { IQueryParameters } from 'common/models';
import { QUERY_KEYS } from 'consts/queryKeys';
import { getProperties } from 'modules/accommodations/features/reservations/api';

interface IProps extends IQueryParameters {
  enabled: boolean | undefined;
}

export const useQueryProperties = ({ params, enabled }: IProps) => {
  const { data: propertiesData, isLoading } = useQuery({
    queryKey: [QUERY_KEYS.RENTALS_PROPERTIES, params],
    queryFn: () => getProperties({ params }),
    enabled: enabled && Object.keys(params).length !== 0,
  });

  return { propertiesData: propertiesData?.items, isLoading };
};
